/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum RingRuleEvaluationStatus {
    NotDrilled = 0,
    Drilled = 1,
    Charged = 2,
    Fired = 3,
    Bogging = 4,
}
